import EnhancedTable from './EnhancedTable.view';

export default EnhancedTable;
